import { render } from "./ApproveMgDetail.vue?vue&type=template&id=7651239b&ts=true"
import script from "./ApproveMgDetail.vue?vue&type=script&lang=tsx"
export * from "./ApproveMgDetail.vue?vue&type=script&lang=tsx"

import "./ApproveMgDetail.vue?vue&type=style&index=0&id=7651239b&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__